import {useState, useEffect} from 'react';
import {Dimensions, Platform} from 'react-native';
import { PDFDocument } from 'pdf-lib';

// Opens a PDF in a new tab given a base64 string.
export const openPDF = async (base64String: string, formId: string | number) => {
  if (typeof window === 'undefined') return;

  try {
    // Decode base64 into binary string
    const binaryString = atob(base64String);
    
    // Convert binary string to Uint8Array
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }

    // Load the PDF and set the title.
    const pdfDoc = await PDFDocument.load(byteArray);
    pdfDoc.setTitle(formId.toString()); // This name will show in the top left corner of the browsers PDF viewer.
    const updatedPdfBytes = await pdfDoc.save();

    // Creating blob and a temporary URL for the blob.
    const blob = new Blob([updatedPdfBytes], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const newTab = window.open(blobUrl, '_blank');
    if (!newTab) {
      alert('Pop-up blocked! Please allow pop-ups for this site.');
    }
  } catch (error) {
    console.error('Failed to load PDF: ', error);
  }
};

export const convertBlobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result as string;
      const base64String = base64data.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
const isIpadOnWeb = (): boolean => {
  if (Platform.OS !== 'web') return false;

  if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
    return false;
  }

  const ua = window.navigator.userAgent || window.navigator.vendor || '';
  return /iPad|Macintosh/i.test(ua) && 'ontouchend' in document;
};

export const getLayoutType = (): 'mobile' | 'tablet' | 'desktop' => {
  const [screenWidth, setScreenWidth] = useState(
    Dimensions.get('window').width,
  );

  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', ({window}) => {
      setScreenWidth(window.width);
    });

    return () => subscription?.remove();
  }, []);
  if (Platform.OS !== 'web' && Platform.isPad) return 'tablet';
  if (isIpadOnWeb()) return 'tablet';
  if (screenWidth < 750) return 'mobile'; // Mobile: < 750px
  if (screenWidth < 1024) return 'tablet'; // Tablet: 640px - 1023px
  return 'desktop'; // Desktop: >= 1024px
};
export const getCookie = (name) => {
  //@ts-ignore
  const match = document.cookie.match(
    new RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'),
  );
  return match;
};

export const isHomeOfficeUser = () => {
  const cookie = getAccountDetailsTokenCookie();
  let isHomeOfcUser = false;

  if (cookie !== null) {
    isHomeOfcUser = true;
  }
  return isHomeOfcUser;
};

export const getAccountDetailsTokenCookie = () => {
  const cookie = getCookie('ACCOUNT_DETAILS_TOKEN');
  let AccountDetailsToken: string | null = null;
  if (cookie !== null) {
    AccountDetailsToken = cookie[1];
  }
  return AccountDetailsToken;
};

export const getSessionId = () => {
  try {
    const sessionId = getCookie('X-OA-SessionID');
    return sessionId;
  } catch (error) {
    console.error('Error retrieving session ID:', error);
    return null;
  }
};

export const formatCurrency = (value: string | number): string => {
  if (!value) return '';
  const numValue = typeof value === 'string' 
    ? parseFloat(value.replace(/[^0-9.-]/g, ''))
    : value;
  return `$${numValue.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
};